import { Alert } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Yönetici eğitim kapanışında bu kullanıcıyı "tamamlamadı / devamsızlıktan kaldı"
 * olarak işaretlediğinde detay sayfasının üstünde gösterilen kırmızı banner.
 */
export function NotCompletedState() {
  const { t } = useTranslation();
  return (
    <Alert
      type="error"
      showIcon
      banner
      message={t("notCompletedState.title")}
      description={t("notCompletedState.subTitle")}
      style={{ borderRadius: 8 }}
    />
  );
}
